import { File } from "@/common/types/file";
import { MaintenanceForwardingEstablishmentChoiceEntryManualEntryData } from "./manualEntry/manualEntry.type";

export enum MaintenanceForwardingEstablishmentChoiceEntryKlass {
  ManualEntry = 'Maintenance::EstablishmentChoice::ManualEntry',
}

export type MaintenanceForwardingEstablishmentChoiceEntryMap = {
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry]: MaintenanceForwardingEstablishmentChoiceEntryManualEntryData;
}

export enum MaintenanceForwardingEstablishmentChoiceEntryProposalStatus {
  AwaitingEstablishmentResponse = 'awaiting_establishment_response',
  AwaitingClientResponse = 'awaiting_client_response',
  Canceled = 'canceled',
}

export type MaintenanceForwardingEstablishmentChoiceEntryProposalData = {
  id: string;
  status: MaintenanceForwardingEstablishmentChoiceEntryProposalStatus;
  process_started_at: string | null;
  canceled_at: string | null;
  establishment_accepted_at: string | null;
  establishment_rejected_at: string | null;
  client_accepted_at: string | null;
  client_rejected_at: string | null;
  establishment: {
    id: string;
    general_information: {
      fantasy_name: string;
      company_logo: File;
    };
  };
  establishment_accepted_by: string | null;
  establishment_rejected_by: string | null;
  client_accepted_by: string | null;
  client_rejected_by: string | null;
}
